module.exports = __webpack_public_path__ + "static/media/YM28_4.2310ca6c.jpg";